import axios from "axios";
import iziToast from "izitoast";
import store from "../store";

axios.defaults.baseURL = process.env.VUE_APP_URL_API;

axios.interceptors.request.use((config) => {
  const token = JSON.parse(localStorage.getItem("token"));

  if (token) {
    if (config.url.search("api/TknCr") !== 1) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  config.headers["Content-Type"] = "application/json";

  try {
    if (!config.data) {
      config.data = {};
    }

    // config.data.dt19 = process.env.VUE_APP_API_KEY;
    // config.data.idTrack = constantes.Constantes.enumeraciones.idApp;
  } catch (e) {
    console.error("Error al configurar el body de la solicitud:", e);
  }

  return config;
});

axios.interceptors.response.use((response) => response, respuestaErro);

function respuestaErro(error) {
  try {
    if (error.response.data) {
      if (error.response.data.dt1)
        iziToast.show({
          theme: "light",
          position: "bottomRight",
          message: error.response.data.dt1,
        });
      if (error.response.data.Message)
        iziToast.show({
          theme: "light",
          position: "bottomRight",
          message: error.response.data.Message,
        });
    }
  } catch (e) {
    iziToast.error({
      theme: "light",
      position: "bottomRight",
      message: String(error),
    });
  }
  return Promise.reject(error);
}

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response ? error.response.status : null;
    if (status === 401) {
      const original = error.config;
      original._retry = true;
      store.commit("setTrue");
      if (store.getters.getEstado === false) {
        await store.dispatch("regenerar");
        store.commit("setFalse");
      }
      original.headers.Authorization = store.getters.getToken;
      return axios.request(original);
    } else {
      return Promise.reject(error);
    }
  }
);
